import { Component, OnInit } from '@angular/core';
import { MaintenanceOrderService, OrderFilters } from 'src/app/services/maintenance-order.service';
import { MaintenanceOrder } from 'src/app/models/maintenance-order';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Maintenance } from 'src/app/models/maintenance';

@Component({
  selector: 'app-maintenance-order-list',
  templateUrl: './maintenance-order-list.component.html',
  styleUrls: ['./maintenance-order-list.component.css']
})
export class MaintenanceOrderListComponent implements OnInit {
  orders:MaintenanceOrder[] = [];
  user:MaintenanceOrder[] = [];
  filters:OrderFilters = {
    status: 'Abierta',
    user: null,
  }
  users:User[] = [];
  loading:boolean = false;
  isAdmin:boolean = false;
  maintenances:Maintenance[] = [];

  constructor(private orderServ:MaintenanceOrderService, private userServ:UserService, private auth:AuthService, private modal:NgbModal) { }

  ngOnInit() {
    this.search();
    this.isAdmin = this.auth.is('Admin');
    if(this.isAdmin) {
      this.userServ.getUsers().then(users => this.users = users);
    }
  }

  search() {
    this.loading = true;
    this.orderServ.getOrders(this.filters).then(orders => {
      this.orders = orders;
      this.userServ.getUsers;
      this.loading = false;
    });
  }

  orderSelected(order:MaintenanceOrder, modal) {
    this.loading = true;

    this.orderServ.getMaintenanceByOrder(order.id).then(resp => {
      this.maintenances = resp;
      this.loading = false;
      this.modal.open(modal, {size: 'lg'});
    });
  }

  calcTotal(m:Maintenance) {
    let total = 0;
    for (let i = 0; i < m.lines.length; i++) {
      let art = m.lines[i];
      total += art.quantity * art.price * (1 + art.iva);
    }

    return total;
  }
}
